import { z } from 'zod';
import type { RelationTypeToken } from '@sleed/bizcommerce-api';

/**
 * Relation type edit form. Mirrors `RelationTypeToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Catalog/RelationTypes/index.js): nm required ≤100, cd required ≤100,
 * desc optional ≤200, iv boolean, si required. The ML sub-token (btrl) and timestamps (cdt/udt) are
 * not surfaced by the legacy grid; they are not tracked here — the default-language name/desc are
 * saved at the top level via the Accept-Language=el pin (parity with PriceTypes/TaxOffices).
 */
export const relationTypeSchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	cd: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	desc: z.string().trim().max(200, 'validation.tooLong').nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type RelationTypeFormValues = z.infer<typeof relationTypeSchema>;

export const EMPTY_RELATION_TYPE: RelationTypeFormValues = {
	nm: '',
	cd: '',
	desc: '',
	iv: true,
	si: 0
};

export function tokenToForm(token: RelationTypeToken): RelationTypeFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		cd: token.cd ?? '',
		desc: token.desc ?? '',
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: RelationTypeFormValues): RelationTypeToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		cd: form.cd.trim(),
		desc: form.desc?.trim() || null,
		iv: form.iv,
		si: form.si
	};
}
